import { useState } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import PropTypes from "prop-types";

function ChatbotLogin({ setToken, onShowRegister }) {
  const [inputToken, setInputToken] = useState("");
  const [error, setError] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginLoading(true);
    setError("");
    try {
      const res = await fetch("https://rieshim.app/v1/chat/completions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${inputToken}`,
        },
        body: JSON.stringify({
          model: "llama-3.1-8b-instant",
          messages: [],
          max_completion_tokens: 1,
        }),
      });
      let data = null;
      try {
        data = await res.json();
      } catch {}
      if (!res.ok) {
        if (res.status === 401) {
          setError("Neplatný token");
        } else if (data && data.detail) {
          setError(data.detail);
        } else {
          setError("Chyba pri overovaní tokenu");
        }
        setLoginLoading(false);
        return;
      }
      setToken(inputToken);
      setError("");
      setLoginLoading(false);
    } catch (err) {
      setError("Chyba siete alebo servera");
      setLoginLoading(false);
    }
  };

  return (
    <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
      <Card sx={{ minWidth: 400 }}>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h5" fontWeight="medium" color="white" mt={1}>
            Prihlásenie do Chatbota
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3} component="form" onSubmit={handleLogin}>
          <MDBox mb={2}>
            <MDInput
              type="password"
              label="Token"
              value={inputToken}
              onChange={(e) => setInputToken(e.target.value)}
              fullWidth
              disabled={loginLoading}
              autoFocus
            />
          </MDBox>
          {error && (
            <MDBox mb={2}>
              <MDTypography color="error" variant="button">
                {error}
              </MDTypography>
            </MDBox>
          )}
          <MDBox mt={4} mb={1}>
            <MDButton
              variant="gradient"
              color="info"
              fullWidth
              type="submit"
              disabled={loginLoading || !inputToken.trim()}
            >
              {loginLoading ? "Overujem..." : "Prihlásiť sa"}
            </MDButton>
          </MDBox>
          <MDBox mt={1} mb={1}>
            <MDButton
              variant="outlined"
              color="info"
              fullWidth
              type="button"
              onClick={onShowRegister}
              disabled={loginLoading}
            >
              Vytvoriť chatbota
            </MDButton>
          </MDBox>
        </MDBox>
      </Card>
    </MDBox>
  );
}

ChatbotLogin.propTypes = {
  setToken: PropTypes.func.isRequired,
  onShowRegister: PropTypes.func.isRequired,
};

export default ChatbotLogin;
